import { BaseComponent } from "../BaseComponent";
import { Shelf } from '../../other/shelf.model';
import { ComponentNames } from 'src/app/helper/componentNames';
import { RackSecurityEnum } from "../../enums/RackSecurityEnum";


export class RackComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.rackComponent;
    }
    wallThickness:number;
    seperator:boolean;
    seperatorThickness:number;
    security:RackSecurityEnum;
    floorThickness:number;
    shelves:Array<Array<Shelf>>;
}